import { persistor } from '@/store/store';

export const redirectToNewCompany = async (dispatch, navigate, result) => {
    dispatch({
        type: 'CHANGE_CURRENT_COMPANY',
        payload: result?.data?.id,
    });
    dispatch({
        type: 'CHANGE_MINIMUM_SCOPE',
        payload: 20,
    });
    navigate('/dashboard-services');
    await persistor.flush();
    window.location.reload();
};
